import { Component } from 'react';
import * as Sentry from '@sentry/react';

const styles = {
  page: {
    minHeight: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    padding: '2rem',
    background: '#0F172A',
    color: '#F8FAFC',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    textAlign: 'center',
  },
  title: { margin: 0, fontSize: '1.5rem', fontWeight: 700 },
  body: { margin: 0, color: '#94A3B8', maxWidth: 420 },
  actions: { display: 'flex', gap: 12, marginTop: 8 },
  btn: {
    padding: '0.6rem 1.1rem',
    borderRadius: 8,
    border: 'none',
    background: '#7C3AED',
    color: '#fff',
    fontSize: '0.9rem',
    fontWeight: 600,
    cursor: 'pointer',
  },
  btnOutline: {
    padding: '0.6rem 1.1rem',
    borderRadius: 8,
    border: '1.5px solid #334155',
    background: 'transparent',
    color: '#94A3B8',
    fontSize: '0.9rem',
    fontWeight: 600,
    cursor: 'pointer',
  },
};

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled UI error:', error, info?.componentStack);
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info?.componentStack } },
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.assign('/');
  };

  render() {
    if (this.state.error) {
      return (
        <div style={styles.page} role="alert">
          <h1 style={styles.title}>Something went wrong.</h1>
          <p style={styles.body}>
            An unexpected error stopped this page from loading. Please reload, or head back home.
          </p>
          <div style={styles.actions}>
            <button type="button" style={styles.btn} onClick={this.handleReload}>
              Reload page
            </button>
            <button type="button" style={styles.btnOutline} onClick={this.handleHome}>
              Go home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
